// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { quickOrderStyles } from "@insite/content-library/Widgets/Basic/QuickOrder";
import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

quickOrderStyles.productSelector = {
    ...quickOrderStyles.productSelector,
    qtyGridItem: {
        width: [4, 4, 2, 2, 2],
        css: css`
            & input {
                padding-left: 10px !important;
                padding-right: 10px !important;
                text-align: center;
                max-width: 100px;
            }
        `,
    },
    container: { gap: 20 },
    searchGridItem: {
        width: [12, 12, 5, 5, 5],
        css: css`
            > ${IconWrapper} {
                top: 40px;
                right: 53px;
            }
        `,
    },
    buttonGridItem: { width: [12, 12, 3, 3, 3] },
};
